import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createBrowserRouter, RouterProvider } from 'react-router';
import { RecoilRoot } from 'recoil';
import { GlobalEffects } from './components/Effects';
import { Layout } from './components/Layout';
import { BroadcastPage } from './pages/BroadcastPage';
import { HomePage } from './pages/HomePage';
import { MerchantOnboardingReturnPage } from './pages/MerchantOnboardingReturnPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RecordingsListPage } from './pages/RecordingsListPage';
import { UnhandledErrorPage } from './pages/UnhandledErrorPage';
const router = createBrowserRouter([
    {
        element: _jsx(Layout, {}),
        errorElement: (_jsx(Layout, { children: _jsx(UnhandledErrorPage, {}) })),
        children: [
            {
                path: '/',
                element: _jsx(HomePage, {}),
            },
            {
                path: '/stream/:streamId',
                element: _jsx(BroadcastPage, {}),
            },
            {
                path: '/recordings/:streamId',
                element: _jsx(RecordingsListPage, {}),
            },
            {
                path: '/merchant-onboarding-return',
                element: _jsx(MerchantOnboardingReturnPage, {}),
            },
            {
                path: '*',
                element: _jsx(NotFoundPage, {}),
            },
        ],
    },
    {
        path: '/embed/:streamId',
        element: _jsx(BroadcastPage, { embedded: true }),
    },
]);
export function App() {
    return (_jsxs(RecoilRoot, { children: [_jsx(GlobalEffects, {}), _jsx(RouterProvider, { router: router })] }));
}
